import { jsxs as c, jsx as r } from "react/jsx-runtime";
import { useState as p } from "react";
import h from "classnames";
import n from "./index.es803.js";
import { ContactNavigationButtons as $ } from "./index.es804.js";
import { findMaxContactFields as j } from "./index.es805.js";
import { Header as z } from "./index.es806.js";
import { DetailRow as W } from "./index.es807.js";
import { useScreenZoom as _ } from "./index.es589.js";
import { BodyText as B } from "./index.es505.js";
const D = "contact-card-component", K = ({
  name: v,
  roles: g,
  address: u,
  contactDetails: l,
  menuItems: x,
  onSelect: A,
  testId: e = D
}) => {
  const [o, d] = p(0), [N, i] = p("left"), a = Array.isArray(l) ? l : [l], C = a.length > 1, y = j(a), { zoomPercentage: I } = _(), s = I >= 200, R = () => {
    if (o + 1 < a.length) {
      const t = o + 1;
      d(t), i(""), t === a.length - 1 && i("right");
    }
  }, T = () => {
    if (o > 0) {
      const t = o - 1;
      d(t), i(""), t === 0 && i("left");
    }
  }, b = a[o], f = Object.entries(b), k = h(n.alternativeContactInfoRowContainer, {
    [n.isWrapping]: s
  }), w = h(n.detailsContainer, {
    [n.withAlternativeContactInfo]: C,
    [n.isWrapping]: s
  });
  return /* @__PURE__ */ c("div", { className: n.contactCardContainer, "data-testid": e, children: [
    /* @__PURE__ */ r(
      z,
      {
        name: v,
        roles: g,
        address: u,
        menuItems: x,
        onSelect: A,
        testId: `${e}-header`,
        isWrapping: s
      }
    ),
    /* @__PURE__ */ c("div", { className: n.body, "data-testid": `${e}-body`, children: [
      C && /* @__PURE__ */ c("div", { className: k, children: [
        /* @__PURE__ */ r(
          B,
          {
            size: "small",
            variant: "regular",
            "data-testid": `${e}-alternative-info`,
            children: "Alternative Contact Info"
          }
        ),
        /* @__PURE__ */ r(
          $,
          {
            onRightClick: R,
            testId: `${e}-navigation-buttons`,
            onLeftClick: T,
            arrivedToLimit: N
          }
        )
      ] }),
      /* @__PURE__ */ c("div", { className: w, children: [
        f.map(([t, m]) => {
          const { label: L, value: S } = m;
          return /* @__PURE__ */ r(
            W,
            {
              field: t,
              label: L,
              value: S,
              testId: e,
              isWrapping: s
            },
            t
          );
        }),
        Array.from(
          // fill with padding according to max contact details
          { length: y - f.length },
          (t, m) => /* @__PURE__ */ r("div", { className: n.detailRowContainer }, m)
        )
      ] })
    ] })
  ] });
};
export {
  D as CONTRACT_CARD_TESTID,
  K as ContactCard
};
//# sourceMappingURL=index.es28.js.map
